import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";

import { AppProviders } from "./providers/AppProviders";
import { router } from "./router";

function PageSpinner() {
  return (
    <div className="flex h-dvh w-screen items-center justify-center bg-background">
      <svg
        className="h-8 w-8 animate-spin text-primary"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12" cy="12" r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
    </div>
  );
}

export function App() {
  return (
    <AppProviders>
      <Suspense fallback={<PageSpinner />}>{/* catches initial app boot only */}
        <RouterProvider router={router} />
      </Suspense>
    </AppProviders>
  );
}
